import type { Take } from '../lib/types';

/** COYG starts with an honest, empty community rather than invented posts. */
export const SEED_TAKES: Take[] = [];
